import { useAuth } from '@/hooks/useAuth';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';

export default function GuestMiddleware() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="grid h-screen place-items-center">
      <Outlet />
    </div>
  );
}
